export default "__VITE_ASSET__BJe5FiOe__"